import HorizontalLine from '../../horizontal-line';
import { useTranslations } from '@fshr/context/i18n-context';
import { TopFiveRecommendations } from '../../types';
import { ProductCard } from '../product-card/product-card';
import Link from '../../link';
import { ArrowRight } from '../../icon/arrow-right';
import { cn } from '@fshr/shared-react';
import BevSafeText from '../../bev-safe-text';

type AncilliariesRecommendationsProps = {
	recommendations?: TopFiveRecommendations[];
	mainContainerClassNames?: string;
	sectionTitle: string;
	redirectLink?: string;
	hideLocation?: boolean;
	placement:
		| 'for_you-other_destinations'
		| 'for_you-guest_favourites'
		| 'for_you-highlighted_ancillary';
};

export function RecommendationsListComponent(props: AncilliariesRecommendationsProps) {
	const {
		recommendations,
		mainContainerClassNames,
		sectionTitle,
		redirectLink,
		hideLocation = false,
		placement,
	} = props;
	const t = useTranslations();

	if (!recommendations?.length) {
		return null;
	}

	return (
		<section className={cn(['w-full flex flex-col spacing-stack-l', mainContainerClassNames])}>
			<HorizontalLine additionalClasses={'border-border-subtle'} />
			<div className="flex flex-col w-full">
				<div className="w-full flex flex-row justify-between items-center spacing-heading-m">
					<h2 className="text-h4 max-w-[71%] md:max-w-full text-text-heading">
						<BevSafeText>{sectionTitle}</BevSafeText>
					</h2>
					{redirectLink ? (
						<Link
							intent="unstyled"
							href={redirectLink}
							className="flex flex-row gap-[10px] text-button2 text-text-primary"
						>
							<div>{t('View All')}</div>
							<ArrowRight />
						</Link>
					) : null}
				</div>

				<div className="w-full flex flex-col spacing-stack-m">
					{recommendations?.map((recommendation, index) => (
						<ProductCard
							placement={placement}
							position={index + 1}
							key={`ancilliary-recommendation-${recommendation.title}-${recommendation.type}-${index}`}
							recommendation={recommendation}
							hideLocation={hideLocation}
						/>
					))}
				</div>
			</div>
		</section>
	);
}
